/**
 * TODO: find a way to tell Babel to polyfill this instead of doing it here.
 * In the meantime, I'm using an AI-improved version of this implementation:
 * https://github.com/mo/abortcontroller-polyfill/blob/b5c6843c03901088fbdd76df7ab775cb2e0cf2c4/src/abortcontroller.js#L93
 */
if (!AbortSignal.timeout) {
  /**
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/AbortSignal/timeout_static}
   * @param {number} time The "active" time in milliseconds before the returned {@link AbortSignal} will abort.
   *                      The value must be within range of 0 and {@link Number.MAX_SAFE_INTEGER}.
   * @returns {AbortSignal} The signal will abort with its {@link AbortSignal.reason} property set to a `TimeoutError` {@link DOMException} on timeout,
   *                        or an `AbortError` {@link DOMException} if the operation was user-triggered.
   */
  AbortSignal.timeout = (time: number) => {
    const milliseconds = Math.max(0, time);
    const controller = new AbortController();

    setTimeout(
      () =>
        controller.abort(
          new DOMException("The operation timed out", "TimeoutError"),
        ),
      milliseconds,
    );

    return controller.signal;
  };
}
